import { useUserStore } from '@/modules/user/stores/userStore'

export const parseTokenAndSetAdmin = (token: string): void => {
  try {
    if (!token) return
    const payloadBase64 = token.split('.')[1]
    const decoded = JSON.parse(atob(payloadBase64))

    const isAdmin = decoded?.CustomClaims?.isAdmin ?? false

    console.log('parseTokenAndSetAdmin decoded isAdmin', isAdmin)

    const userStore = useUserStore()
    if (userStore.user) {
      userStore.user.isAdmin = isAdmin
      console.log('parseTokenAndSetAdmin userStore.user.isAdmin', userStore.user.isAdmin)
    }
  } catch (error) {
    console.error('Ошибка при разборе токена:', error)
  }
}
